export default function Disclaimer({ compact = false }: { compact?: boolean }) {
  return (
    <p className={`text-muted-foreground ${compact ? "text-xs" : "text-sm"}`}>
      For informational and entertainment purposes only. AleaEdge does not accept bets, provide
      gambling services, or guarantee outcomes. Users are responsible for their own decisions.
      If you or someone you know has a gambling problem, call <span className="font-semibold">1-800-GAMBLER</span>.
    </p>
  );
}
